import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Importar modulos que se van a compartir en toda la aplicacion
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { ConfirmationService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SelectModule } from 'primeng/select';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { AdminTableComponent } from './components/admin-table/admin-table.component';
import { ImportFileAComponent } from './components/import-file-a/import-file-a.component';
import { InputFormComponent } from './components/input-autocomplete/input-form.component';
import { InputCodeotpComponent } from './components/input-codeotp/input-codeotp.component';
import { PaymentConfirmationComponent } from './components/payment-confirmation/payment-confirmation.component';
import { PaymentMethodComponent } from './components/payment-method/payment-method.component';
import { PayzenPaymentComponent } from './components/payzen-payment/payzen-payment.component';
import { StripePaymentComponent } from './components/stripe-payment/stripe-payment.component';
import { PlanViewPriceComponent } from './components/plan-view-price/plan-view-price.component';
import { CustomCurrencyPipe } from "./pipes/custom-currency-pipe";
import { EmailFilterPipe } from './pipes/email-filter.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { MultiSelectModule } from 'primeng/multiselect';
import { SchedulingFormComponent } from './components/scheduling-form/scheduling-form.component';
import { InputIdEntityComponent } from './components/input-id-entity/input-id-entity.component';
import { LangSwitcherComponent } from './components/lang-switcher/lang-switcher.component';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { ScoreRingComponent } from './components/score-ring/score-ring.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { AgentPanelComponent } from './components/agent-panel/agent-panel.component';
import { JuanaAvatarComponent } from './components/juana-avatar/juana-avatar.component';
import { JuanaCardRendererComponent } from './components/juana-card-renderer/juana-card-renderer.component';
import { JuanaWidgetComponent } from './components/juana-widget/juana-widget.component';
import { JuanaProductCardComponent } from './components/juana-product-card/juana-product-card.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    AutoCompleteModule,
    FormsModule,
    InputOtpModule,
    StepsModule,
    ToastModule,
    RadioButtonModule,
    ReactiveFormsModule,
    InputMaskModule,
    SelectModule,
    MultiSelectModule,
    PopoverModule,
    DividerModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    DialogModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    TagModule,
    DatePickerModule,
    InputNumberModule,
    ToggleSwitchModule,
    FileUploadModule,
    MessageModule,
    MenuModule,
    CustomCurrencyPipe,
    GoogleMapsModule,
    RatingModule,
    TooltipModule,
    TranslocoModule,
    RouterModule
  ],
  declarations: [
    EmailFilterPipe,
    InputFormComponent,
    InputCodeotpComponent,
    AdminTableComponent,
    PayzenPaymentComponent,
    StripePaymentComponent,
    ImportFileAComponent,
    PlanViewPriceComponent,
    PaymentMethodComponent,
    PaymentConfirmationComponent,
    OrderByPipe,
    SchedulingFormComponent,
    InputIdEntityComponent,
    LangSwitcherComponent,
    CardInfoComponent,
    StatusBadgeComponent,
    ScoreRingComponent,
    TimelineComponent,
    AgentPanelComponent,
    JuanaAvatarComponent,
    JuanaCardRendererComponent,
    JuanaWidgetComponent,
    JuanaProductCardComponent
  ],
  exports: [
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    AutoCompleteModule,
    EmailFilterPipe,
    OrderByPipe,
    FormsModule,
    InputFormComponent,
    InputOtpModule,
    InputCodeotpComponent,
    StepsModule,
    ToastModule,
    RadioButtonModule,
    ReactiveFormsModule,
    InputMaskModule,
    SelectModule,
    MultiSelectModule,
    PopoverModule,
    DividerModule,
    TableModule,
    AdminTableComponent,
    IconFieldModule,
    InputIconModule,
    PayzenPaymentComponent,
    StripePaymentComponent,
    DialogModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    TagModule,
    DatePickerModule,
    InputNumberModule,
    ImportFileAComponent,
    ToggleSwitchModule,
    FileUploadModule,
    MessageModule,
    MenuModule,
    PlanViewPriceComponent,
    PaymentMethodComponent,
    PaymentConfirmationComponent,
    CustomCurrencyPipe,
    GoogleMapsModule,
    RatingModule,
    SchedulingFormComponent,
    InputIdEntityComponent,
    LangSwitcherComponent,
    TooltipModule,
    TranslocoModule,
    CardInfoComponent,
    StatusBadgeComponent,
    ScoreRingComponent,
    TimelineComponent,
    AgentPanelComponent,
    JuanaAvatarComponent,
    JuanaCardRendererComponent,
    JuanaWidgetComponent,
    JuanaProductCardComponent
  ],
  providers: [DialogService, DynamicDialogRef, ConfirmationService]
})
export class SharedModule {}